module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5201e4d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/BackButton.vue
// module id = 29
// module chunks = 0